import Post from "@components/Post";
import { Typography } from "@mui/material";
import React from "react";
import ShowMore from "./ShowMore";
import axios from "../../MyAxios";

export default function EventPostsList(props) {
  // accept events from different prop names used across the app
  const { events, posts, EPosts, page, totalPages, onShowMore } = props;
  const list = events ?? posts ?? EPosts ?? [];

  const [voteStatuses, setVoteStatuses] = React.useState({});
  React.useEffect(() => {
    if (!list || list.length === 0) return;

    const ids = list
      .map((p) => {
        const isEvent =
          p.startTime ||
          p.endTime ||
          p.eventType ||
          String(p.id).startsWith("event-");

        return isEvent
          ? (String(p.id).startsWith("event-") ? p.id : `event-${p.id}`)
          : p.id;
      })
      .filter(Boolean);

    if (ids.length === 0) return;


    axios
      .post("/post/vote-status-bulk", {
        ids,
      })
      .then((res) => {
        setVoteStatuses((prev) => ({
          ...prev,
          ...res.data,
        }));
      })
      .catch((err) => {
        console.error("Failed to fetch bulk vote status", err);
      });

  }, [list]);

  return (
    <div>
      {list.length === 0 && (
        <Typography className="mt-2 text-center py-8">
          No event posts found
        </Typography>
      )}
      {list.length > 0 && (
        <div>
          {list.map((item) => (
            <div key={item?.id} className=" border-b-2">
              <Post post={item} comment={true}
                voteStatus={
                  voteStatuses[
                  item?.startTime || item?.eventType || String(item.id).startsWith("event-")
                    ? `event-${item.id.replace("event-", "")}`
                    : item.id
                  ]
                }
              />
            </div>
          ))}
          <ShowMore page={page} totalPages={totalPages} onClick={onShowMore} />
        </div>
      )}
    </div>
  );
}
